export const getRiskColor = ({
  key,
  high = "high",
  medium = "medium",
  normal = "normal",
}) => {
  const toLowerKey = key ? key.toLowerCase() : "";

  if (toLowerKey.includes(high)) {
    return "#D92315";
  }

  if (toLowerKey.includes(medium)) {
    return "#FCB925";
  }

  if (toLowerKey.includes(normal)) {
    return "#0AD172";
  }

  return "#000000";
};



// WEBPACK FOOTER //
// ./src/utilities/riskColor.js